/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Tree from 'avl'

import { BasicComparator, areEqual, areDeepEqual } from 'fierry/type/compare';


export default class Map
{
  constructor (entries = [])
  {
    this.tree = new Tree(BasicComparator, true);

    for (const [key, value] of entries)
    {
      this.set(key, value);
    }
  }


  insert (key, value)
  {
    this.tree.insert(key, value);
  }


  set (key, value)
  {
    const node = this.tree.find(key);

    if (node)
    {
      node.data = value;
    }
    else
    {
      this.tree.insert(key, value);
    }
  }


  remove (key)
  {
    this.tree.remove(key);
  }


  get (key)
  {
    const node = this.tree.find(key);

    return node ? node.data : null;
  }


  contains (key)
  {
    return this.tree.contains(key);
  }


  size ()
  {
    return this.tree.size;
  }


  empty ()
  {
    return this.tree.size === 0;
  }


  keys ()
  {
    return this.tree.keys();
  }


  values ()
  {
    return this.tree.values();
  }


  toArray ()
  {
    let entries = [];

    this.tree.forEach(node =>
    {
      entries.push({ key: node.key, value: node.data });
    });

    return entries;
  }


  deepEquals (rhs)
  {
    if (!(rhs instanceof Map) || this.size() !== rhs.size())
    {
      return false;
    }

    const entries = rhs.toArray();

    return this.toArray().every((entry, index) =>
    {
      return areEqual(entry.key, entries[index].key) && areDeepEqual(entry.value, entries[index].value);
    });
  }


  *[Symbol.iterator]()
  {
    for (const entry of this.toArray())
    {
      yield entry;
    }
  }


};
